//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/TaggedObject.js";
let d=[[[0,"AngularTolerance",1,0],[0,"CreateCurveOption",1,0],[0,"DistanceTolerance",1,0],[0,"Section",1,"Section",0],[0,"SimplifyCurveOption",1,0]],[[["path_location","n_curves"],"EvaluateOneSketch",{R_:{curves:"Curve[]"}},1,0],[[],"Destroy",{},0,0]],[]];
SPLM.SketchEvaluator = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.SketchEvaluator";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;